import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StylesService } from '../services/styles.service';
import { LoaderService } from '../services/loader.service';

@Injectable({
  providedIn: 'root'
})
export class CssLoaderGuard {
  constructor(
    private readonly stylesService: StylesService,
    private readonly loaderService: LoaderService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const cssUrl = `${next.routeConfig?.path}`;
    return this.stylesService
      .loadCss(cssUrl, state.url)
      .then(() => {
        return true;
      })
      .catch(() => false);
  }
}
